<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  ></main-breadcrumb>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Detalle de cilindro</custom-title>
    </template>
    <template #right>
      <el-button
        type="primary"
        size="default"
        :icon="IconEdit"
        @click="editItem"
        >Editar</el-button
      >
      <home-delete-button></home-delete-button>
    </template>
  </main-buttons-bar>
  <detail-container>
    <el-row :gutter="20">
      <custom-data
        :label="'Tipo cilindro'"
        :spanColumn="4"
        :data="cylinder.CilindroTipo.Descripcion"
      ></custom-data>
      <custom-data
        :label="'Desarrollo'"
        :spanColumn="4"
        :data="cylinder.Desarrollo.Desarrollo"
      ></custom-data>
      <custom-data
        :label="'Engranaje'"
        :spanColumn="4"
        :data="cylinder.Desarrollo.Engranaje"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Cantidad magneticos'"
        :spanColumn="4"
        :data="cylinder.CantidadMagneticos"
      ></custom-data>
      <custom-data
        :label="'Cantidad cilindros'"
        :spanColumn="4"
        :data="cylinder.CantidadCilindros"
      ></custom-data>
      <custom-data
        :label="'Cantidad almas de stamping'"
        :spanColumn="4"
        :data="cylinder.CantidadAlmasStamping"
      ></custom-data>
      <custom-data
        :label="'Cantidad cilindros de relieve en línea'"
        :spanColumn="4"
        :data="cylinder.CantidadCilindrosRelieveEnLinea"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Paso'"
        :spanColumn="4"
        :data="cylinder.Desarrollo.Paso"
      ></custom-data>
      <custom-data
        :label="'Activo'"
        :spanColumn="4"
        :data="cylinder.Activo === true ? 'Si' : 'No'"
      ></custom-data>
    </el-row>
  </detail-container>
</template>
<script setup>
import { onBeforeMount } from 'vue';
import { useCylinderStore } from '../stores/cylinders_store.js';
import { storeToRefs } from 'pinia';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomData from '@/shared/components/custom_data.vue';
import IconEdit from '~icons/mdi/edit';
const cylinderStore = useCylinderStore();

const { findOneDesarrolloCilindroTipoHTTP } = cylinderStore;
const { cylinder } = storeToRefs(cylinderStore);
const route = useRoute();
const router = useRouter();

// local state
const items = [
  { label: 'Inicio', to: '/page/cylinders/list', replace: false },
  { label: 'Detalle', to: null, replace: false },
];

const editItem = () =>
  router.replace(
    `/page/cylinders/edit/${route.params.CodigoCilindroTipo}/${route.params.CodigoDesarrollo}`,
  );

onBeforeMount(() => {
  const CodigoCilindroTipo = route.params.CodigoCilindroTipo;
  const CodigoDesarrollo = route.params.CodigoDesarrollo;
  if (CodigoCilindroTipo && +CodigoCilindroTipo > 0 && CodigoDesarrollo && +CodigoDesarrollo > 0) {
    findOneDesarrolloCilindroTipoHTTP(CodigoCilindroTipo, CodigoDesarrollo);
  }
});
</script>

<style scoped></style>
